<template>
  <div>
    <ul class="decorate">
      <template  v-for="(item,index) in list">
      <li
        class="elements"
        v-if='item'
        :key='index'
        :style="[setBgStyle(item),setPosition(index)]"></li>
        </template>
      </ul>
  </div>
</template>
<script>
const SPACING = 120;
const elementHeight = 400;
const elementTop = 746;
export default {
  props:{
    list:{
      type:Array,
      default:()=>{}
    }
  },
  methods:{
    setPosition(index){
      const topNumer = index === 0
        ? index * SPACING + elementTop : index * (SPACING + elementHeight) + elementTop
      const isRight = index % 2 === 0 ? 'right' : 'left';
      return {
        [isRight]: '0',
        top: `${topNumer}px`,
      };
    },
    setBgStyle(url) {
      return {
        'backgroundImage':`url(http://cdn.xiaohoucode.com/${url})`,
        'background-position':'center',
        'background-repeat':'no-repeat',
        'background-size':'100%',
      }
    },
  }
}
</script>
<style lang="less" scoped>
.elements{
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: absolute;
  width: 400px;
  height: 400px;
  z-index: -1;
}
</style>